import React, { Component } from "react"
import { Field, reduxForm } from "redux-form"
import { connect } from "react-redux"
import { DropdownList } from "react-widgets"
import fetch from "isomorphic-fetch"

import * as actions from "../../actions/notification"

let tmpEventsList

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) =>
  <div
    className={`form-group ${touched && error
      ? "has-danger"
      : touched && warning ? "has-warning" : ""}`}
  >
    <label className="form-control-label">
      {label}
    </label>
    <input
      {...input}
      placeholder={label}
      type={type}
      className={`form-control ${touched && error
        ? "form-control-danger"
        : touched && warning ? "form-control-warning" : ""}`}
    />
    {touched &&
      ((error &&
        <div className="form-text text-muted">
          {error}
        </div>) ||
        (warning &&
          <span className="form-text text-muted">
            {warning}
          </span>))}
  </div>

const renderDropdownList = ({ input, defaultValue }) =>
  <DropdownList
    {...input}
    valueField="id"
    textField="name"
    data={tmpEventsList}
    value={input.value !== "" ? input.value : null}
  />

export class NewNotification extends Component {
  constructor(props) {
    super(props)

    this.state = {
      notification: {}
    }

    this.sendPush = this.sendPush.bind(this)
  }

  componentWillMount() {
    fetch(`${process.env.REACT_APP_EF_API_URL}/events/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(json => {
        //console.error('WE HAVE A RESULT: ' + JSON.stringify(json))
        //dispatch(fetchVenuesSuccess(json.venues))
        tmpEventsList = json.events
        this.handleInitialize()
      })
      .catch(error => console.error(error))
  }

  handleInitialize() {
    console.log("init push form")
    const notification = {
      title: "",
      subTitle: "",
      pushType: "event",
      event: tmpEventsList[0]
    }

    this.props.initialize(notification)

    this.setState({
      notification
    })
  }

  sendPush() {
    //console.log("push: " + JSON.stringify(this.props.notification.item))
    this.props.newNotification(this.props.notification.item)
  }

  handleFormSubmit(formProps) {
    const notificationProps = {
      title: formProps.title,
      subTitle: formProps.subTitle,
      eventId: formProps.event._id,
      pushType: formProps.pushType
    }

    //console.log(notificationProps)
    this.props.createNotificationConfirmation(notificationProps)
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Oops!</strong> {this.props.errorMessage}
        </div>
      )
    }
  }

  render() {
    const { handleSubmit } = this.props

    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else if (this.props.notification.showConfirmation) {
      return (
        <div>
          <blockquote className="blockquote">
            <h1>Send Push Notification Confirmation</h1>
          </blockquote>
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">
              Are you sure you want to send this push notification now?
            </h4>
            <p>
              NB: If you just added a new event{" "}
              <u>
                please ensure you leave 1hr before sending a notification
              </u>{" "}
              due to API caching.
            </p>
          </div>
          <div className="card">
            <div className="card-block">
              <h5>
                You are sending a notification of type{" "}
                <strong>
                  <u>
                    {" "}{this.props.formValues.newnotification.values.pushType}
                  </u>
                </strong>{" "}
                attached to the specific event{" "}
                <strong>
                  <u>
                    {this.props.formValues.newnotification.values.event.name}
                  </u>
                </strong>.
              </h5>
              <hr />
              <h3 className="card-title">
                {this.props.formValues.newnotification.values.title}
              </h3>
              <p className="card-text">
                {this.props.formValues.newnotification.values.subTitle}
              </p>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-success"
            onClick={this.sendPush}
          >
            Yes, send it now!
          </button>
          &nbsp;
          <a href="/notifications/new" className="btn btn-danger" role="button">
            Nope! Go back please
          </a>
        </div>
      )
    } else {
      return (
        <div>
          <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
            <button action="submit" className="btn btn-success float-xs-right">
              Create
            </button>
            <blockquote className="blockquote">
              <h1>Create Push Notification</h1>
            </blockquote>
            <div className="well">
              <fieldset className="form-group">
                <label>
                  <Field
                    name="pushType"
                    component="input"
                    type="radio"
                    value="event"
                  />{" "}
                  <span className="block teal" /> Event
                </label>
                <br />
                <label>
                  <Field
                    name="pushType"
                    component="input"
                    type="radio"
                    value="video"
                  />{" "}
                  <span className="block yellow" /> Video
                </label>
                <br />
                <label>
                  <Field
                    name="pushType"
                    component="input"
                    type="radio"
                    value="podcast"
                  />{" "}
                  <span className="block red" /> Podcast
                </label>
              </fieldset>

              <fieldset className="form-group">
                <Field
                  name="title"
                  type="text"
                  component={renderField}
                  label="Notifiction Title"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="subTitle"
                  type="text"
                  component={renderField}
                  label="Notification Sub Ttile"
                />
              </fieldset>
              <div className="alert alert-success">Event</div>
              <div className="well">
                <fieldset className="form-group">
                  <Field
                    name="event"
                    component={renderDropdownList}
                    label="Event"
                  />
                </fieldset>
              </div>
            </div>
          </form>
        </div>
      )
    }
  }
}

function validate(formProps) {
  const errors = {}

  if (formProps.title === "") {
    errors.title = "Please enter a notification title"
  }

  if (formProps.subTitle === "") {
    errors.subTitle = "Please enter a notification sub title"
  }

  return errors
}

const form = reduxForm({
  form: "newnotification",
  validate
})

function mapStateToProps(state) {
  //console.log("new state: " + JSON.stringify(state.notification))
  return {
    events: state.events,
    notification: state.notification,
    formValues: state.form
  }
}

export default connect(mapStateToProps, actions)(form(NewNotification))



/** WEBPACK FOOTER **
 ** ./src/components/notifications/new.js
 **/